<template>

  <!--[if lt IE 10]>

  <![endif]-->
  <!-- .auth -->
  <main class="auth auth-floated">
    <loading :active.sync="callingAPI" :can-cancel="false" :is-full-page="fullPage" loader="bars" color="#346cb0" :width="40"></loading>
    <div id="announcement" class="auth-announcement" style="background-image: url(assets/images/illustration/focus.png);">
      <div class="welcome">
        <div class="row">
          <div class="col-md-10 align-left mt-4">
            <h3>Welcome to</h3>
            <h1 class="product-name">One<span style="font-weight: 550;">Trace</span></h1>
            <span class="badge bg-highlight">Development Version</span>
          </div>
          <div class="col-md-2 text-right">
            <div class="btn-group">
              <button class="btn btn-default btn-xs lang-button" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <em class="fa fa-globe"></em> English <span class="caret"></span>
              </button>
              <ul class="dropdown-menu dropdown-menu-right">
                <li><a href="#">Germany</a></li>
                <li><a href="#">Indonesian</a></li>
              </ul>
            </div>
          </div>
        </div>
        <carousel :per-page="1" :autoplayHoverPause="true" :autoplay="true" :mouse-drag="false" :loop="true" :autoplayTimeout="10000" autoplayDirection="forward" easing="ease">
          <slide>
            <div class="item active align-left">
              The web and mobile applications from <strong>OneTrace</strong> enable more efficient processes and reporting across your organization in Product Management, Contact/Customer Management, Human Resources, Travel and Time Management, Procurement and Logistics, Bookkeeping and Invoicing, Content Management and Communications, and Project Management.
            </div>
          </slide>
          <slide style="outline: none !important;">
            <div class="item align-left">
              <strong>OneTrace</strong> is the office suite covering all management and administration needs of your organization and projects. With <strong>OneTrace</strong>, you have a one-stop service tool available for all tasks in project acquisition, project management, and project evaluation.
            </div>
          </slide>
        </carousel>
      </div>
      <div class="welcome-footer row">
        <div class="col-md-4 align-left">
          Developed by <br>
          <img src="assets/images/logo_koltiva_whitebg.svg" alt="Koltiva" width="100">
          &nbsp;&nbsp;
          <img src="assets/images/logo_never_ending_innovation_white.svg" alt="Koltiva" width="70">
        </div>
        <div class="col-md-3">
          <!-- Supported by -->
        </div>
        <div class="col-md-5 welcome-footer-links text-right">
          <ul class="list-inline mb-0">
            <li><a href="https://koltiva.com#aboutus" target="_blank" rel="noopener noreferrer">About Us</a></li>
            <li><a href="https://koltiva.com#contact" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
            <li><a href="https://koltiva.com#services" target="_blank" rel="noopener noreferrer">Services</a></li>
            <li class="link-icon">
              <a href="https://www.linkedin.com/company/pt-koltiva/" target="_blank" rel="noopener noreferrer"><em class="fab fa-linkedin"></em></a>
            </li>
            <li class="link-icon">
              <a href="https://www.youtube.com/channel/UCEEMooggYyT1lQHRl-jJReQ" target="_blank" rel="noopener noreferrer"><em class="fab fa-youtube"></em></a>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <form class="auth-form"  @submit.prevent="login">
        <div class="padding">
          <div class="mb-4">
            <div class="mb-3">
              <img class="rounded" src="assets/images/oneTrace-Logo.png" alt="" height="72">
            </div>
            <div class="mb-3">
              <h4 class="h4 float-left orange">Safe and Secure </h4><br/>
            </div>

            <p class="float-left" style="color: #555555">Sign in into your Account!</p>
          </div>
          <div class="form-group">
            <div class="input-group">
              <input id="inputUser" name="user" v-model="username" type="text" class="form-control form-control-lg" placeholder="Username" autofocus="" tabindex="2" required="">
              <span class="input-group-btn">
            <button class="btn btn-default" type="button" >
              <em class="fa fa-user"></em>
            </button>
          </span>
            </div>
          </div>

          <!-- .form-group -->
          <div class="form-group">
            <div class="input-group">
              <input id="inputPassword" name="password" v-model="password" type="password" class="form-control form-control-lg" placeholder="Password" tabindex="2" required="">
              <span class="input-group-btn">
            <button id="togglePassword" class="btn btn-default" type="button" @click="readPassword">
                <em :class="{'fa fa-eye-slash':isHide(), 'fa fa-eye':!isHide()}"></em>
            </button>
          </span>
            </div>
            <div class="form-text text-right">
              <a href="/forgot-password" class="orange">Lost your password?</a>
            </div>
          </div>
          <!-- .form-group -->
          <div class="form-group mb-4">
            <button class="btn btn-lg btn-primary btn-block background-orange" type="submit">LOG IN</button>
          </div><!-- /.form-group -->
          <!-- .form-group -->
          <div class="form-group text-center">
            <div class="custom-control custom-control-inline custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="remember-me"> <label class="custom-control-label" for="remember-me">Keep me sign in</label>
            </div>
          </div><!-- /.form-group -->
          <div class="form-text text-center mt-40">
            <ul class="list-inline">
              <li><a href="https://koltiva.com/privacy-policy.php" target="_blank" rel="noopener noreferrer" class="primary-color orange">Privacy Policies</a></li>
              <li><a href="#" class="primary-color orange">Terms of Use</a></li>
            </ul>
          </div>
        </div>

        <!-- recovery links -->
        <!-- copyright -->
        <div class="login-footer bg-primary float-right">
          <span id="copyright">2020</span> © All rights reserved. PT. Koltiva
        </div>
      </form>
  </main>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel';
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: "Login",
  components: {
    Carousel,
    Slide,
    Loading
  },
  data(){
    return {
      username:"",
      password:"",
      class_pass:"",
      hide:true,
      countClick:0,
      fullPage:true
    }
  },
  computed:{
    ...mapGetters(['callingAPI'])
  },
  methods: {
    ...mapActions(['authRequest']),
    login: function () {
      this.countClick++

      if (this.countClick>1){
        this.errorMessage("Please wait")
      }
      const { username, password } = this
      let token = 1234
      let user = { username, password,  token}

      this.authRequest(user).then(resp=>{
        if (resp.data.success){
          let path = (this.$route.query.redirect !== undefined? this.$route.query.redirect:"/")
          let ini = this

          this.$router.push({path:path}).then(()=>{
           ini.$router.go()
          })
        }else{
          this.errorMessage(resp.data.message)
        }
      }).catch(err =>{
        console.log(JSON.stringify(err))
        if (err.code === "ECONNABORTED"){
          this.errorMessage("Please try again")
        }else{
          this.errorMessage(err.response.data.message)
        }
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    isHide(){
      return  this.hide
    },
    readPassword() {
      let x = document.getElementById("inputPassword");
      if (x.type === "password") {
        x.type = "text";
        this.hide = false
      } else {
        this.hide = true
        x.type = "password";
      }
    }
  }
}
</script>
<style scoped>
.orange{
  color:#f49944;
}
.background-orange{
  background-color:#f49944;
  border-color: #f49944;
  border-radius: 2rem;
}
.bg-primary {
  background-color: #EF7D22 !important;
}
.login-footer {
  bottom: 20px;
  font-size: 14px;
  color: #fafafa;
  padding: 10px 0;
  text-align: center;
  position: absolute;
  width: 100%;
  max-width: 100%;
}
.list-inline > li {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}

.padding {
  padding:3rem 2rem 1rem;
}

.welcome-footer{
  width: 65%;
  position: absolute;
  bottom: 20px;
  font-size: 12px;
}

.align-left{
  text-align: left;
}

.welcome-footer-links{
  margin-top: 15px;
}

.welcome-footer-links a {
  color: #FFFFFF !important;
  font-size: 14px;
}
a {
  color: #428bca;
  text-decoration: none;
  background-color: transparent;
}

.welcome-footer-links li.link-icon > a {
  font-size: 21px;
}
.welcome {
  width: 62%;
  position: absolute;
  top: 20px;
}
.product-name {
  color: #EF7D22;
  font-weight: 700;
  font-size: 42px;
  letter-spacing: -3px;
}

.product-name > span {
  color: #34495E;
  font-weight: 300;
}

.welcome .badge {
  margin: 10px 0;
  font-weight: normal;
}
.bg-highlight {
  background-color: #f7530e !important;
}
.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  background-color: #777777;
  border-radius: 10px;
}

.lang-button {
  border-radius: 10px !important;
  padding: 1px 8px;
  background-color: #34495E;
  border-color: #cccccc;
  color: #fafafa;
  color: #fafafa;
}

.open > .dropdown-menu {
  display: block;
}
.dropdown-menu-right {
  left: auto;
  right: 0;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
}
.dropdown-menu > li > a {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: normal;
  line-height: 1.42857143;
  color: #333333;
  white-space: nowrap;
}
.VueCarousel-dot:focus{
  outline: none;
}
</style>